'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { SocialVK, SocialOdnoklassniki, SocialYoutube, SocialTelegram } from '@s7/icons';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const variants = {
    vk: SocialVK,
    odnoklassniki: SocialOdnoklassniki,
    youtube: SocialYoutube,
    telegram: SocialTelegram
};
const FooterSocialItemIcon = (props)=>{
    const { variant } = props, others = _object_without_properties_loose(props, [
        "variant"
    ]);
    const Icon = variants[variant];
    return Icon ? /*#__PURE__*/ jsx(Icon, _extends({}, others)) : null;
};

export { FooterSocialItemIcon };
//# sourceMappingURL=FooterSocialItemIcon.js.map
